import { confirmedStories, heroLead, hotRanking } from "@/mocks/homeContent";

export default function HeroSection() {
  const lead = heroLead;
  const sideCards = confirmedStories.slice(1, 3);
  const quickList = hotRanking.slice(0, 4);

  return (
    <section className="w-full bg-background-50 px-4 py-6 md:px-8 md:py-9">
      <div className="mb-5 flex flex-col gap-3 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <span className="mb-2.5 inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700">
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-live-line animate-pulseSoft text-sm"></i>
            </span>
            学生圈 · 实时爆料滚动中
          </span>
          <h2 className="font-heading text-2xl font-bold leading-tight tracking-tight text-foreground-950 md:text-[34px]">
            黑料学生爆料现场，先看这一屏
          </h2>
          <p className="mt-2.5 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-[15px]">
            把学生圈的黑料学生爆料、黑料学生实锤与黑料学生黑历史集中成一张可扫的卡片墙，
            实锤、被扒、翻车瓜持续更新，吃瓜不迷路。
          </p>
        </div>
        <div className="flex shrink-0 items-center gap-2">
          <a
            href="#briefs"
            className="inline-flex cursor-pointer items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
          >
            <i className="ri-flashlight-line"></i>
            看最新爆料
          </a>
          <a
            href="#discussion"
            className="inline-flex cursor-pointer items-center gap-1.5 rounded-md border border-background-300/70 bg-background-50 px-4 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 whitespace-nowrap"
          >
            <i className="ri-chat-3-line"></i>
            进讨论区
          </a>
        </div>
      </div>

      <div className="grid gap-4 lg:grid-cols-12 lg:gap-5">
        <a
          href="#stories"
          className="group relative col-span-1 block h-[320px] overflow-hidden rounded-lg border border-background-200/70 bg-background-100 md:h-[420px] lg:col-span-7 lg:h-[468px]"
        >
          <img
            src={lead.cover}
            alt="黑料学生爆料头条封面：社团经费线索整理"
            title="黑料学生爆料 - 头条实锤"
            className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/78 via-black/35 to-transparent"></div>
          <div className="absolute bottom-0 left-0 right-0 p-5 md:p-7">
            <span className="mb-2.5 inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
              <i className="ri-shield-star-line"></i>
              {lead.tag}
            </span>
            <h3 className="font-heading text-xl font-bold leading-snug text-background-50 md:text-[26px]">
              {lead.title}
            </h3>
            <p className="mt-2.5 max-w-xl text-sm leading-relaxed text-white/75">{lead.summary}</p>
            <div className="mt-4 flex items-center gap-4 text-xs text-white/65">
              <span className="flex items-center gap-1.5">
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-time-line text-sm"></i>
                </span>
                {lead.time}
              </span>
              <span className="flex items-center gap-1.5">
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-eye-line text-sm"></i>
                </span>
                {lead.views}
              </span>
            </div>
          </div>
        </a>

        <div className="col-span-1 flex flex-col gap-4 lg:col-span-5 lg:gap-5">
          <div className="grid grid-cols-2 gap-4 lg:flex lg:flex-1 lg:flex-col lg:gap-5">
            {sideCards.map((story) => (
              <a
                key={story.id}
                href="#stories"
                className="group relative block h-[168px] overflow-hidden rounded-lg border border-background-200/70 bg-background-100 lg:h-0 lg:flex-1"
              >
                <img
                  src={story.cover}
                  alt={`黑料学生实锤封面：${story.title}`}
                  title={`${story.title} - 黑料学生`}
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.05]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <span className="mb-2 inline-flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-0.5 text-[11px] font-medium text-foreground-950">
                    {story.tag}
                  </span>
                  <h3 className="font-heading text-sm font-semibold leading-snug text-background-50 md:text-[15px]">
                    {story.title}
                  </h3>
                </div>
              </a>
            ))}
          </div>

          <div className="rounded-lg border border-background-200/70 bg-background-100 p-4 md:p-5">
            <div className="mb-3 flex items-center justify-between">
              <h3 className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
                <span className="flex h-4 w-4 items-center justify-center text-primary-500">
                  <i className="ri-fire-line text-base"></i>
                </span>
                热点速览
              </h3>
              <a
                href="#hot"
                className="cursor-pointer text-xs text-foreground-500 transition-colors hover:text-primary-600 whitespace-nowrap"
              >
                完整榜单
              </a>
            </div>
            <ul className="flex flex-col gap-2.5">
              {quickList.map((item) => (
                <li key={item.rank}>
                  <a href="#hot" className="group flex items-center gap-3">
                    <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded text-[11px] font-semibold text-primary-700">
                      {String(item.rank).padStart(2, "0")}
                    </span>
                    <span className="flex-1 truncate text-[13px] text-foreground-700 transition-colors group-hover:text-primary-600">
                      {item.title}
                    </span>
                    <span className="shrink-0 text-[11px] text-foreground-400">{item.heat}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}